<template>
  <div
    class="text-area-container"
    :class="{ hasDetails }"
  >
    <label class="form-label-text">
      {{ customLabel || label }}
    </label>
    <slot name="description" />
    <v-textarea
      v-bind="{ ...$props, ...$attrs }"
      flat
      variant="outlined"
      density="compact"
      single-line
    >
      <slot />
      <template #append-inner>
        <slot name="append" />
      </template>
      <template #message="props">
        <slot
          name="message"
          v-bind="props"
        >
          {{ props.message }}
        </slot>
      </template>
    </v-textarea>
  </div>
</template>
<script>
export default {
  name: 'DpplTextArea',
  props: {
    label: { type: String, default: '' },
    customLabel: { type: String, default: null },
    hasDetails: { type: Boolean, default: false },
  },
  emits: ['update'],
};
</script>
<style scoped lang="less">
.text-area-container {
  text-align: left;
  :deep(.v-text-field) {
      margin-top: 4px;
    }
  :deep(.v-text-field .v-text-field__details) {
      margin-top: 4px;
      margin-bottom: 0;
      padding-left: 0;
    }

  :deep(.v-field) {
    padding: 0;

    textarea {
      color: @text-darkest;
      font-weight: 300;
    }

    .v-field__outline__start, .v-field__outline__end {
      border-color: @text-darkest;
    }

    &.v-field--focused {
      .v-field__outline__start, .v-field__outline__end {
        border-color: @text-brand;
      }
    }
  }

  // always hide error message container
  :deep(.v-input__details) {
    display: none;
  }
  // but show it if there's an error or hasDetails set to true
  .v-input--error, &.hasDetails {
    :deep(.v-input__details) {
      display: initial;
    }
  }
}
</style>
